<template>
    <div>
      <v-card class="pa-5">
        <v-card-text>
          <v-card-title>
            <h4>{{$t('reports.checklistReport')}}</h4>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="filterData()" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                  <v-icon small>fas fa-search</v-icon>
                </v-btn>
              </template>
              <span>{{$t('general.search')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn @click="resetFilter" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                  <v-icon small>fa-solid fa-eraser</v-icon>
                </v-btn>
              </template>
              <span>{{$t('general.resetFilter')}}</span>
            </v-tooltip>
            <v-btn v-if="report4.length > 0" @click="download" :loading="loadingButton" color="primary">
              {{$t('reports.downloadReport')}}
              <v-icon small class="ml-2">fas fa-cloud-download-alt</v-icon>
            </v-btn>
          </v-card-title>
         <v-card-text class="pt-4">
            <v-form v-model="valid" lazy-validation ref="form">
              <v-row dense>
                <v-col cols="3">
                  <v-autocomplete
                    clearable
                    outlined
                    dense
                    :items="unitTypes"
                    item-text="alias"
                    item-value="id"
                    v-model="filter.unitType"
                    :label="$t('general.unitType')"
                    class=""
                  />
                </v-col>
                <v-col cols="3">
                  <v-autocomplete
                    clearable
                    outlined
                    dense
                    :items="sites"
                    item-text="name"
                    item-value="id"
                    v-model="filter.site"
                    :label="$t('general.yard')"
                    class=""
                  />
                </v-col>
                <v-col cols="3">
                  <v-autocomplete v-model="filter.inpector" :items="users" :item-text="getInspector" item-value="id" label="Inspector" clearable outlined dense multiple>
                    <template v-slot:selection="data">
                      <v-chip small color="primary">
                        {{ data.item.name + ' ' + data.item.last_name }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete :items="usersOperators" :item-text="getOperatorName" item-value="id"  v-model="filter.operator_id" :label="$t('general.operator')"  clearable outlined dense></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-autocomplete :items="tests" item-text="name" item-value="id"  v-model="filter.checklist_id" :label="$t('reports.checklist')" clearable outlined dense></v-autocomplete>
                </v-col>
                <v-col v-if="filter.dateRange" cols="3">
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.date_start"
                        :label="$t('general.startDate')"
                        outlined
                        dense
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      no-title
                      color="primary"
                      v-model="filter.date_start"
                      @input="handleDateStartSelection"
                      :allowed-dates="allowedStartDates"
                      :day-style="getDayStyle"
                    />
                  </v-menu>
                </v-col>
                <v-col v-if="filter.dateRange" cols="3">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.date_end"
                        :label="$t('general.endDate')"
                        outlined
                        dense
                        prepend-icon="event"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      no-title
                      color="primary"
                      v-model="filter.date_end"
                      @input="menu2 = false"
                      :allowed-dates="allowedEndDates"
                      :day-style="getDayStyle"
                    />
                  </v-menu>
                </v-col>
                <v-col cols="3">
                  <v-checkbox v-model="filter.dateRange" :label="$t('general.dateRange')" hide-details class="mt-0" color="primary"/>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-overlay absolute opacity="0" :value="loadingTable"/>
          <v-data-table
            :loading="loadingTable"
            :loading-text="$t('general.loading')"
            :headers="headers"
            :items="report4"
            :server-items-length="optionsDataTable.totalItems"
            :single-expand="false"
            :options.sync="optionsDataTable"
            :footer-props="{ 'items-per-page-options': [50, 70, 100] }"
            @update:page="get"
            @update:items-per-page="get"
            @update:sort-by="get"
            @update:sort-desc="get"
            item-key="id"
          >
            <template v-slot:item.inspection:consecutive_number="{ item }">
              {{ item.section.inspection ? item.section.inspection.consecutive_number : 'N/A' }}
            </template>
            <template v-slot:item.inspection:type="{ item }">
              {{ translateType(item.section.inspection.type)}}
            </template>
            <template v-slot:item.inspection:name="{ item }">
              {{ item.section.inspection ? item.section.inspection.name : 'N/A' }}
            </template>
            <template v-slot:item.inspection:questionnaire_name="{ item }">
              {{ item.section.inspection ? item.section.inspection.questionnaire_name : 'N/A' }}
            </template>
            <template v-slot:item.inspection:created_at="{ item }">
              {{ item.section.inspection ? formatDateTime(item.section.inspection.created_at) : 'N/A' }}
            </template>
            <template v-slot:item.inspection:duration="{ item }">
              {{ item.section.inspection.duration ? item.section.inspection.duration : 'N/A' }}
            </template>
            <template v-slot:item.site:name="{ item }">
              {{ item.section.inspection.site ? item.section.inspection.site.name : 'N/A' }}
            </template>
            <template v-slot:item.user:name="{ item }">
              {{ item.section.inspection.user ? (item.section.inspection.user.name + ' ' + item.section.inspection.user.last_name) : 'N/A' }}
            </template>
            <template v-slot:item.operator:name="{ item }">
              {{ item.section.inspection ? (item.section.inspection.current_operator || (item.section.inspection.operator ? (item.section.inspection.operator.name + ' ' + item.section.inspection.operator.last_name) : 'N/A')) : 'N/A' }}
            </template>
            <template v-slot:item.inspection:client="{ item }">
              {{ item.section.inspection.client ? item.section.inspection.client : 'N/A' }}
            </template>
            <template v-slot:item.inspection:transit="{ item }">
              {{ translateTransit(item.section.inspection.transit) }}
            </template>
            <template v-slot:item.inspection:loaded="{ item }">
             <span>
              {{ item.section.inspection && item.section.inspection.loaded !== null && item.section.inspection.loaded !== undefined  ? (item.section.inspection.loaded ? $t('inspections.yes') : $t('inspections.no'))  : 'N/A' }}
              </span>
            </template>
            <template v-slot:item.inspection:document_type="{ item }">
              {{ translateDocumentType(item.section.inspection.document_type) }}
            </template>
            <template v-slot:item.inspection:origin="{ item }">
              {{ item.section.inspection.origin ? item.section.inspection.origin : 'N/A' }}
            </template>
            <template v-slot:item.inspection:destination="{ item }">
              {{ item.section.inspection.destination ? item.section.inspection.destination : 'N/A' }}
            </template>
            <template v-slot:item.section:name="{ item }">
              {{ item.section.name ? item.section.name : 'N/A' }}
            </template>
            <template v-slot:item.answer="{ item }">
              <span>
                {{ item.answer !== null && item.answer !== undefined ? (item.answer === 1 ? $t('general.ok') : $t('general.damages')) : 'N/A' }}
              </span>
            </template>
            <template v-slot:item.comment="{ item }">
              {{ item.comment ? item.comment : '' }}
            </template>
            <template v-slot:item.unit_types:name="{ item }">
              {{ item.section.unitTypes ? item.section.unitTypes.alias : 'N/A' }}
            </template>
            <template v-slot:item.plate_number="{ item }">
              {{ item.section.unit && item.section.unit.plates && item.section.unit.plates.length > 0 ? item.section.unit.plates[0].plate_number : 'N/A' }}
            </template>
            <template v-slot:item.unitNumber="{ item }">
              {{ item.section.unit ? item.section.unit.unit_number : 'N/A' }}
            </template>
            <template v-slot:item.damage_level="{ item }">
              {{ translateDamageLevel(item.damage_level) }}
            </template>
            <template v-slot:item.issues_notes="{ item }">
              {{ item.issues_notes ? item.issues_notes : 'N/A' }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
<script>
  export default {
    data () {
      return {
        valid: true,
        loadingTable: false,
        loadingButton: false,
        menu: false,
        menu2: false,
        options: {
          link: '',
          itemsPerPage: 15,
          page: 1,
          total: 0
        },
        optionsDataTable: {
          itemsPerPage: 15,
          page: 1,
          total: 0
        },
        filter: {
          site_id: null,
          unit_type: null,
          operator_id: null,
          inpector_id: null,
          checklist_id: null,
          dateRange: true,
          date_start: this.returnStartDate(),
          date_end: this.returnEndDate()
        },
        report4: [],
        sites: [],
        users: [],
        unitTypes: [],
        usersOperators: [],
        tests: []
      }
    },
    watch: {
      sites (val) {
        if (val.length > 0) this.options.itemsPerPage = 10
      },
      'filter.dateRange' (val) {
        if (!val) {
          this.filter.date_start = null
          this.filter.date_end = null
        } else {
          this.filter.date_start = this.returnStartDate()
          this.filter.date_end = this.returnEndDate()
        }
      }
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('general.noInspection'),
            align: 'center',
            value: 'inspection:consecutive_number'
          },
          {
            text: this.$t('general.typeInspection'),
            align: 'center',
            value: 'inspection:type'
          },
          {
            text: this.$t('notification.title'),
            align: 'center',
            value: 'inspection:name'
          },
          {
            text: 'CheckList',
            align: 'center',
            value: 'inspection:questionnaire_name'
          },
          {
            text: this.$t('general.date'),
            align: 'center',
            value: 'inspection:created_at'
          },
          {
            text: this.$t('general.duration'),
            align: 'center',
            value: 'inspection:duration'
          },
          {
            text: this.$t('general.yard'),
            align: 'center',
            value: 'site:name'
          },
          {
            text: 'Inspector',
            align: 'center',
            value: 'user:name'
          },
          {
            text: this.$t('general.operat'),
            align: 'center',
            value: 'operator:name'
          },
          {
            text: this.$t('general.customer'),
            align: 'center',
            value: 'inspection:client'
          },
          {
            text: this.$t('general.transitType'),
            align: 'center',
            value: 'inspection:transit'
          },
          {
            text: this.$t('inspections.charge'),
            align: 'center',
            value: 'inspection:loaded'
          },
          {
            text: this.$t('general.loadType'),
            align: 'center',
            value: 'inspection:document_type'
          },
          {
            text: this.$t('general.origin'),
            align: 'center',
            value: 'inspection:origin'
          },
          {
            text: this.$t('general.destination'),
            align: 'center',
            value: 'inspection:destination'
          },
          {
            text: this.$t('general.section'),
            align: 'center',
            value: 'section:name',
            sortable: false
          },
          {
            text: this.$t('monitoring.question'),
            align: 'center',
            value: 'name'
          },
          {
            text: this.$t('general.answer'),
            align: 'center',
            value: 'answer'
          },
          {
            text: this.$t('general.comments'),
            align: 'center',
            value: 'comment'
          },
          {
            text: this.$t('general.unitType'),
            align: 'center',
            value: 'unit_types:name'
          },
          {
            text: this.$t('general.plate'),
            align: 'center',
            value: 'plate_number',
            sortable: false
          },
          {
            text: this.$t('general.noEco'),
            align: 'center',
            value: 'unitNumber',
            sortable: false
          },
          {
            text: this.$t('general.damageLevel'),
            align: 'center',
            value: 'damage_level'
          },
          {
            text: this.$t('general.damageNotes'),
            align: 'center',
            value: 'issues_notes'
          }
        ]
      },
      rules () {
        return this.$validationRules()
      }
    },
    created () {
      this.$store.dispatch('sites/get', { event: { context: this, item: { perPage: -1, page: 1 } } }),
      this.$store.dispatch('users/getInspect', { event: { context: this, item: { perPage: -1, page: 1 } } }),
      this.$store.dispatch('unitTypes/getAll', { event: { context: this } })
      this.$store.dispatch('users/getOperators', { event: { context: this, perPage: -1, page: 1, isSelectOperator: true } }),
      this.$store.dispatch('tests/get', { event: { context: this, item: { perPage: -1, page: 1 } } }),

      this.get()
    },
    methods:{
      formatDateTime (value) {
        if (!value) return 'N/A'
        return value.replace('T', ' ').substring(0, 16)
      },
      returnStartDate() {
        const now = new Date()
        return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substr(0, 10)
      },
      returnEndDate() {
        const now = new Date()
        return new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().substr(0, 10)
      },
      resetFilter() {
        this.filter = {
          site_id: null,
          unit_type: null,
          operator_id: null,
          checklist_id: null,
          inpector_id: null,
          dateRange: true,
          date_start: this.returnStartDate(),
          date_end: this.returnEndDate()
        }

        if(this.optionsDataTable.page === 1) return this.get()

        this.optionsDataTable.page = 1
      },
      filterData(){
        if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)

        if(this.optionsDataTable.page === 1) return this.get()

        this.optionsDataTable.page = 1
      },
      getInspector(user) {
        return `${user.name} ${user.last_name === null ? '' : user.last_name}`;
      },
      getOperatorName(user) {
        return `${user.name} ${user.last_name === null ? '' : user.last_name}`;
      },
      viewItem (id) {
        this.$router.push('/inspectionUnitTypes/view/' + id)
      },
      download () {
        if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)
        
        this.loadingButton = true
      
        this.$store.dispatch('reports/getcheckListDoc', {
          event: {
            context: this,
            ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC',
            params: {
              perPage: this.optionsDataTable.itemsPerPage,
              page: this.optionsDataTable.page,
              type: 'download',
              date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
              date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
              site_id: this.filter.site,
              inpector_id: this.filter.inpector,
              unit_type_id: this.filter.unitType,
              checklist_id: this.filter.checklist_id,
              operator_id: this.filter.operator_id,
              sortKey: this.optionsDataTable.sortBy ? this.optionsDataTable.sortBy[0] : 'id',
              find: this.filter.find,
            }
          }
        })
      },
      get () {
        this.loadingTable = true

        this.$store.dispatch('reports/getcheckList', {
          event: {
            context: this,
            params: {
              date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
              date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
              inpector_id: this.filter.inpector,
              unit_type_id: this.filter.unitType,
              checklist_id: this.filter.checklist_id,
              operator_id: this.filter.operator_id,
              site_id: this.filter.site,
              find: this.filter.find,
              page: this.optionsDataTable.page,
              perPage: this.optionsDataTable.itemsPerPage,
              sortKey: (this.optionsDataTable.sortBy && this.optionsDataTable.sortBy.length > 0)  ? this.optionsDataTable.sortBy[0] : 'id',
              ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC',
              type: 'json'
            }
          }
        })
      },
      translateTransit(value) {
        const transitMap = {
          'INPUT': this.$t('inspections.input'),
          'OUTPUT': this.$t('inspections.output'),
          'ON_ROUTE': this.$t('inspections.on_route')
        }

        return transitMap[value] || 'N/A'
      },
      translateDocumentType(value) {
        const documentTypeMap = {
          'EXPORT': this.$t('inspections.export'),
          'IMPORT': this.$t('inspections.import'),
          'EMPTY': this.$t('inspections.empty'),
          'EMPTY_PREMISES': this.$t('inspections.emptyPremises'),
          'LOADED': this.$t('inspections.loaded'),
          'THROWING': this.$t('inspections.throwing'),
          'OUTSIDER': this.$t('inspections.outsider')
        }
        return documentTypeMap[value] || 'N/A'
      },
      translateDamageLevel(value) {
        const damageLevelMap = {
          'SOFT': this.$t('inspections.slight'),
          'MODERATE': this.$t('inspections.moderate'),
          'HARD': this.$t('inspections.high'),
          'NONE': this.$t('inspections.none')
        }

        return damageLevelMap[value] || 'N/A'
      },
      translateType(value) {
        const typeInspectionMap = {
          'SECURITY': this.$t('sites.typeQuestionnaire.security'),
          'MAINTENANCE': this.$t('sites.typeQuestionnaire.maintenance'),
          'LOG': this.$t('sites.typeQuestionnaire.log')
        }

        return typeInspectionMap[value] || 'N/A'
      },
      translateAswer(value) {
        const AnswerMap = {
          'SECURITY': this.$t('sites.typeQuestionnaire.security'),
          'MAINTENANCE': this.$t('sites.typeQuestionnaire.maintenance'),
          'LOG': this.$t('sites.typeQuestionnaire.log')
        }

        return AnswerMap[value] || 'N/A'
      },
      handleDateStartSelection(date) {
        this.filter.date_start = date
        this.updateDateEnd()
        this.menu = false
      },
      allowedStartDates() {
        return true
      },
      allowedEndDates(date) {
        if (!this.filter.date_start) return true;

        const startDate = new Date(this.filter.date_start)
        const endDateLimit = new Date(startDate)
        endDateLimit.setDate(startDate.getDate() + 29)

        return new Date(date) >= startDate && new Date(date) <= endDateLimit
      },
      updateDateEnd() {
        if (this.filter.date_start) {
          const startDate = new Date(this.filter.date_start)
          const endDateLimit = new Date(startDate)
          endDateLimit.setDate(startDate.getDate() + 29)

          this.filter.date_end = endDateLimit.toISOString().substr(0, 10)
        }
      },
      getDayStyle(date) {
        if ((this.filter.date_start && this.allowedEndDates(date)) || (!this.filter.date_start && this.allowedStartDates(date))) {
          return null
        }

        return { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'gray' }
      },
    }
  }
</script>